<template>
  <div v-if="data">
    <div class="container">
      <div class="clearfix"></div>
      <br />
      <!-- About this app -->
      <div class="row">
        <div class="col-sm"></div>
        <div class="col-md-4 card" v-if="referral">
          <h4 class="text-info" v-html="data.testResult.testResultsHeader"></h4>
          <div class="clearfix"></div>
          <!-- Test result: Not available -->
          <p v-if="referral.labTest === 0" v-html="data.testResult.testResultNotAvailable"></p>
          <!-- Test result: Negative -->
          <p v-if="referral.labTest === 1" v-html="data.testResult.testResultNegative"></p>
          <!-- Test result: Error -->
          <div class="wrapper" v-if="referral.labTest === 2">
            <p v-html="data.testResult.testResultError"></p>
            <div class="clearfix"></div>
            <button
              class="btn btn-block btn-primary btn-referral"
              @click="requestNewReferral()"
              :disabled="hasReqNewReferral"
              v-html="data.testResult.requestNewReferralBtn">
            </button>
            <div class="clearfix"></div>
            <!-- If successful with requesting new referral -->
            <div class="alert alert-success" v-if="alertSuccess"
              role="alert" v-html="data.testResult.testResultNewReferral">
            </div>
            <!-- If error occurs with requesting new referral -->
            <div class="alert alert-danger" v-if="alertError"
              role="alert" v-html="data.error.errorHeader">
            </div>
            <!-- If error is status 409 -->
            <div class="alert alert-danger" v-if="alert409"
              role="alert" v-html="data.error.error409">
            </div>
            <!-- If error is status 417 -->
            <div class="alert alert-danger" v-if="alert417 && alert417.visible"
              role="alert" v-html="alert417.msg">
            </div>
          </div>
          <!-- Test result: Pending result -->
          <p v-if="referral.labTest === 3" v-html="data.testResult.testResultNotAvailable"></p>
        </div>
        <div class="col-sm"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { request } from '../plugins/datocms'
import { parseJwt } from '../plugins/jwtparser'
import config from '../../config/index.js'
import axios from '../plugins/axios'

export default {
  name: 'testresult',
  components: {},
  data () {
    return {
      data: null,
      referral: {
        byRid: null,
        labTest: null
      },
      jwt: null,
      hasReqNewReferral: false,
      alertSuccess: false,
      alertError: false,
      alert409: false,
      alert417: {
        visible: false,
        msg: null
      },
      isDev: process.env.NODE_ENV === 'dev',
      isQa: process.env.NODE_ENV === 'qa'
    }
  },
  methods: {
    async getReferralLabTestResult () {
      let loader = this.$loading.show()
      axios._get(config.referralUri + config.labTestResultUri).then(response => {
        this.referral.labTest = response.data
        loader.hide()
      }).catch((error) => {
        if (error.response && error.response.status === 401) {
          window.location.href = window.location.origin.concat('/error')
        } else {
          console.log('Could not get labtestresult from referral. Error: ' + error)
          loader.hide()
        }
      })
    },
    requestNewReferral () {
      this.alertError = false
      this.alert417.visible = false
      let loader = this.$loading.show()
      const labId = (this.isDev || this.isQa) ? config.labid_karolinska_test : config.labid_karolinska_prod
      axios.postReferral(
        config.referralUri, sessionStorage.getItem('language'), labId
      ).then((response) => {
        if (response.status === 200) {
          loader.hide()
          sessionStorage.setItem('hasReqNewRef', true)
          this.hasReqNewReferral = true
          this.alertSuccess = true
        }
      }, (error) => {
        if (error.response && error.response.status === 401) {
          window.location.href = window.location.origin.concat('/error')
        } else if (error.response && error.response.status === 409) {
          loader.hide()
          this.alert409 = true
        } else if (error.response && error.response.status === 417) {
          loader.hide()
          this.alert417.visible = true
          this.alert417.msg = error.response.data.errorMessage
        } else {
          loader.hide()
          this.alertError = true
        }
      })
    }
  },
  async beforeMount () {
    this.jwt = parseJwt(sessionStorage.getItem('jwt'))
    this.hasReqNewReferral = sessionStorage.getItem('hasReqNewRef') !== null
      ? sessionStorage.getItem('hasReqNewRef') : false
    await this.getReferralLabTestResult()
  },
  async mounted () {
    this.data = await request({
      query: `
        {
          testResult(locale: ` + sessionStorage.getItem('language') + `) {
            testResultsHeader
            testResultNotAvailable
            testResultNegative
            testResultError
            testResultNewReferral
            labTestResultsEnum
            requestNewReferralBtn
          }
          error(locale: ` + sessionStorage.getItem('language') + `) {
            errorHeader
            error409
          }
        }
      `
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.container {
  padding-bottom: 8vh;
}
.card {
  min-height: 500px !important;
}
.btn-referral:disabled {
  opacity: 0.4;
}
/* Portrait and Landscape */
@media only screen
  and (min-device-width: 300px)
  and (max-device-width: 812px) {
  .container {
    margin-top: 2vh;
    margin-bottom: -7.5vh;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TestResult.vue